export const frontendVersion =
"0.2.20250331"
